module.exports = __webpack_public_path__ + "img/m-banner-ltwjyxtc-en-US.f4cde47d.jpg";